export default __webpack_public_path__ + "static/Seth_TOCartoonist-e6db5cdc088f68bd0b0db660ab4d95ec.mp4";